module.exports = __webpack_public_path__ + "img/PizzaTeilen-NÖÖ.1cf7edd7.svg";